const storage = window.localStorage;
export { storage as Storage };
